export const formatIntlCurrency = (amount, locale = 'en') => {
  // format amount based on intl.locale en/fr
  let formattedAmount = amount;
  if (locale === 'fr') {
    formattedAmount = new Intl.NumberFormat('fr-CA', {
      style: 'currency',
      currency: 'CAD',
    }).format(amount);
  } else {
    formattedAmount = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    }).format(amount);
  }
  return formattedAmount;
};
